import "./CardHover.scss";
const CardHover = ({ url, title, link }) => {
  return (
    <div>
      <a
        className="d-flex flex-column justify-content-center align-items-center p-3 mb-3 card-hover"
        href={link}
      >
        <img src={url} width={156} className="mb-2" />
        <div
          className="m-0 d-inline"
          style={{
            fontWeight: "bold",
            fontSize: "16px",
            lineHeight: "24px",
            textAlign: "center",
            color: "rgb(138, 141, 143)",
          }}
        >
          {title}
        </div>
      </a>
    </div>
  );
};

export default CardHover;
